import { useInfiniteQuery } from "@tanstack/react-query";
import { logStreamEventContract } from "@common/contracts/log-stream-event.contract";
import { LogStreamEventResponse } from "@common/schemas/logStreamEvent.schema";
import { getBackendAPIClient } from "@lib/backendAPIClient";

const logStreamEventContractClient = getBackendAPIClient(
    logStreamEventContract,
);

const logStreamEventQueryKeys = {
    all: ["log-stream-events"] as const,
    list: (limit: number) => [...logStreamEventQueryKeys.all, limit] as const,
};

const PAGE_SIZE = 10;

export const useLogStreamEvents = () =>
    useInfiniteQuery<LogStreamEventResponse, Error>({
        queryKey: logStreamEventQueryKeys.list(PAGE_SIZE),
        queryFn: ({ pageParam = 1 }) =>
            logStreamEventContractClient
                .getLogStreamEvents({
                    query: { page: pageParam as number, limit: PAGE_SIZE },
                })
                .then((r) => r.body),
        getNextPageParam: (lastPage) =>
            lastPage.page < lastPage.pageCount ? lastPage.page + 1 : undefined,
        initialPageParam: 1,
    });
